export const MENU_STATES = {
  START_MENU: "START_MENU",
  ABOUT: "ABOUT",
  GAME_ON: "GAME_ON",
  GAME_OVER_WON: "GAME_OVER_WON",
  GAME_OVER_LOST: "GAME_OVER_LOST",
  OPTIONS: "OPTIONS",
  PAUSE: "PAUSE",
  DEBUG: "DEBUG"
};
